import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const borderSpacingMap = {
  sm: '0 0.5rem',
  normal: '0 1rem'
}

const Table = ({ className, head, body, spacing = 'sm', values, notValues, ...props }) => {
  return (
    <table
      className={clsx('border-separate', className)}
      style={{ borderSpacing: borderSpacingMap[spacing] }}
      {...props}
    >
      {values?.length > 0 ? (
        <>
          {head && <thead className="text-left">{head}</thead>}
          {body && <tbody>{body}</tbody>}
        </>
      ) : (
        <tbody>{notValues}</tbody>
      )}
    </table>
  )
}

export default Table

Table.propTypes = {
  head: PropTypes.element,
  body: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  values: PropTypes.arrayOf(PropTypes.object),
  notValues: PropTypes.node,
  className: PropTypes.string,
  spacing: PropTypes.string
}
